import { createRouter, createWebHistory } from 'vue-router'
import CreateTicket from "@/views/CreateTicket";
import ShowAndSearch from "@/views/ShowAndSearch";
import ProposalTickets from "@/views/ProposalTickets.vue";

const routes = [
  {
    path: '/',
    name: 'Мои обращения',
    component: ShowAndSearch
  },
  {
    path: '/create',
    name: 'Создать обращение',
    component: CreateTicket
  },
  {
    path: '/proposal',
    name: 'Заявки заказчику',
    component: ProposalTickets
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  linkActiveClass: 'is-active',
  routes
})

export default router
